import './App.css';
function App() {
  return <div className='App'>Hasi</div>;
}

export default App;
